import { titles, type MediaType, type TitleItem } from "@/mocks/titles";

export { titles };
export type { MediaType, TitleItem };

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  drama: "电视剧",
};

export const genrePool = [
  "剧情",
  "悬疑",
  "爱情",
  "犯罪",
  "治愈",
  "都市",
  "青春",
  "校园",
  "美食",
  "生活",
  "家庭",
  "科幻",
  "惊悚",
  "音乐",
  "励志",
  "文艺",
  "医疗",
];

export const yearOptions = [2026, 2025, 2024];

export function getTitleById(id: string | undefined): TitleItem | undefined {
  if (!id) return undefined;
  return titles.find((item) => item.id === id);
}

export function getTitlesByType(type: MediaType): TitleItem[] {
  return titles.filter((item) => item.type === type);
}

export function getLatest(limit?: number): TitleItem[] {
  const sorted = [...titles].sort((a, b) => b.year - a.year || b.heat - a.heat);
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getHot(limit?: number): TitleItem[] {
  const sorted = [...titles].sort((a, b) => b.heat - a.heat);
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getRelated(item: TitleItem, limit = 4): TitleItem[] {
  const sameType = titles.filter(
    (t) => t.id !== item.id && t.type === item.type,
  );
  const scored = sameType
    .map((t) => ({
      item: t,
      score:
        t.genre.filter((g) => item.genre.includes(g)).length * 10 +
        (t.region === item.region ? 4 : 0) +
        t.heat / 20,
    }))
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.item);
}

export function searchTitles(keyword: string, pool: TitleItem[] = titles): TitleItem[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return pool.filter((item) => {
    const haystack = [
      item.title,
      item.originalTitle,
      item.director,
      ...item.cast,
      ...item.genre,
      item.region,
      String(item.year),
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}

export interface FilterState {
  year: string;
  region: string;
  genre: string;
  sort: string;
}

export const defaultFilter: FilterState = {
  year: "全部",
  region: "全部",
  genre: "全部",
  sort: "最新",
};

export function applyFilter(list: TitleItem[], filter: FilterState): TitleItem[] {
  const result = list.filter((item) => {
    if (filter.year !== "全部" && String(item.year) !== filter.year) return false;
    if (filter.region !== "全部" && item.region !== filter.region) return false;
    if (filter.genre !== "全部" && !item.genre.includes(filter.genre)) return false;
    return true;
  });

  if (filter.sort === "最热") {
    return [...result].sort((a, b) => b.heat - a.heat);
  }
  if (filter.sort === "评分") {
    return [...result].sort((a, b) => b.rating - a.rating);
  }
  return [...result].sort((a, b) => b.year - a.year || b.heat - a.heat);
}

export function isFilterActive(filter: FilterState): boolean {
  return (
    filter.year !== "全部" ||
    filter.region !== "全部" ||
    filter.genre !== "全部" ||
    filter.sort !== "最新"
  );
}